import type { Theme } from "@/shared/theme/theme";

const SWITCHING_ATTRIBUTE = "data-theme-switching";

/** The browser chrome (address bar, phone status bar) takes the canvas colour of the theme. */
function syncThemeColor(root: HTMLElement): void {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  const canvas = getComputedStyle(root).getPropertyValue("--color-canvas").trim();
  if (meta && canvas) meta.content = canvas;
}

/**
 * Show a theme on the page: data-theme on <html> switches every colour token (index.css). The
 * colours change at once, without each control animating its own transition.
 */
export function applyTheme(theme: Theme, root: HTMLElement = document.documentElement): void {
  if (root.dataset.theme === theme) {
    syncThemeColor(root);
    return;
  }
  root.setAttribute(SWITCHING_ATTRIBUTE, "");
  root.dataset.theme = theme;
  syncThemeColor(root);
  // Styles are recalculated on the next frame; transitions come back after it.
  window.requestAnimationFrame(() => {
    root.removeAttribute(SWITCHING_ATTRIBUTE);
  });
}
